import type { IconProps } from './types';

export function MeiaCalca({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M88 32 Q128 28 168 32 Q168 44 168 56 Q170 128 172 200 Q164 220 144 224 Q132 224 132 212 Q130 154 128 96 Q126 154 124 212 Q124 224 112 224 Q92 220 84 200 Q86 128 88 56 Q88 44 88 32 Z" />
      <path d="M88 56 Q128 60 168 56" />
    </svg>
  );
}
